// Localization config (Morocco)

import { Localization } from '../../../shared/Localization';

import ar from '../../generic/l10n/messages_ar';
import fr from '../../generic/l10n/messages_fr';
import en from '../../generic/l10n/messages_en';

const localization = new Localization('default_ma', ar, [ar, fr, en]);

export default localization;
